import React, { Component } from 'react';
import {connect} from "react-redux";
import './App.css';
import {Router} from 'react-router-dom';
import {history} from "./store/store";
import withAuthentication from "./hocs/withAuthentication";
import PageLayout from "./components/PageLayout/PageLayout";
import CircularProgress from "@material-ui/core/CircularProgress";
import Layout from "./components/AdminLayout/layout";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {colors} from './helpers/colors';
import { setupNotificationClickHandler } from './services/notificationClickHandler';

class App extends Component {
    componentDidMount() {
        // Set up notification click handler
        setupNotificationClickHandler();
    }

    render() {
        const theme = createMuiTheme({
            palette: {
                type: 'dark',
                primary: { 
                    main: colors.PRIMARY,
                    dark: colors.PRIMARY_DARK,
                    light: colors.PRIMARY_LIGHT,
                },
                secondary: { 
                    main: colors.SUCCESS,
                },
                background: {
                    default: colors.DARK_BG,
                    paper: colors.DARK_SURFACE,
                },
                text: {
                    primary: colors.TEXT_PRIMARY,
                    secondary: colors.TEXT_SECONDARY,
                },
            },
            typography: {
                fontFamily: [
                    '-apple-system',
                    'BlinkMacSystemFont',
                    '"Segoe UI"',
                    'Roboto',
                    '"Helvetica Neue"',
                    'Arial',
                    'sans-serif',
                ].join(','),
            },
            overrides: {
                MuiPaper: {
                    root: {
                        backgroundImage: 'none',
                    },
                },
            },
        });
        if(this.props.fetchingCurrentUserInfo && !this.props.roleCode){
            return (
                <div className='agent-login-page'>
                    <CircularProgress className='spinner'/>
                </div>
            )
        }

        let UserLayout = () => null;
        if(this.props.roleCode === "admin"){
            UserLayout = Layout;
        }

        if(this.props.roleCode === "agent"){
            UserLayout = PageLayout
        }

        return (
          <MuiThemeProvider theme={theme}>
            <Router history={history}>
                <UserLayout/>
            </Router>
          </MuiThemeProvider>
        );
    }
}

const mapStateToProps = (state) => ({
    roleCode: state.user.info.roleCode,
    fetchingCurrentUserInfo: state.user.fetchingInfo
});

const mapDispatchToProps = (dispatch) => ({});

export default withAuthentication(connect(mapStateToProps, mapDispatchToProps)(App));
